import { Col, Row, Typography, Radio, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { FaPlusCircle } from 'react-icons/fa';
import config from '../../config.json';
import { useNavigate } from 'react-router';
import { getContractsByClient, statsByStatus } from '../../services/contractService';
import StyledRadio from '../../components/styledRadio';
import auth from "../../services/authService";
import ServicesTable from './ServicesTable';
import ClientSelect from '../../components/common/ClientSelect';

const { Title } = Typography;
const { statusContract } = config;

const STATUS_STYLES = [
	{
		color: '#FF8C00',
		text: 'Todos',
		status: '',
		rol: 'SERVICE_FILTER_ALL'
	},
	{
		color: '#69B5EC',
		text: 'Solicitudes',
		status: statusContract.solicitado,
		rol: 'SERVICE_FILTER_SOL'
	},
	{
		color: '#228B22',
		text: 'Instalado',
		status: statusContract.instalado,
		rol: 'SERVICE_FILTER_INS'
	},
	{
		color: '#a0d911',
		text: 'Instalación Aprobada',
		status: statusContract.instalacionAprobada,
		rol: 'SERVICE_FILTER_IAP'
	},
	{
		color: '#fa541c',
		text: 'Instalación Rechazada',
		status: statusContract.instalacionRechazada,
		rol: 'SERVICE_FILTER_IRE'
	},
	{
		color: '#36EF80',
		text: 'Activo',
		status: statusContract.activo,
		rol: 'SERVICE_FILTER_ACT'
	},
	{
		color: '#E8D850',
		text: 'Suspendido',
		status: statusContract.suspendido,
		rol: 'SERVICE_FILTER_SUS'
	},
	{
		color: '#EC2A2A',
		text: 'Cancelado',
		status: statusContract.cancelado,
		rol: 'SERVICE_FILTER_CAN'
	}
];

export default function Services() {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [stats, setStats] = useState({});
	const [selectedClient, setSelectedClient] = useState(null);
	const [data, setData] = useState([]);

	useEffect(() => {
		setLoading(true);

		statsByStatus()
			.then(({ data }) => {
				const items = data.reduce((acc, item) => {
					acc[item.statusId] = item.count;
					return acc;
				}, {});
				setStats(items);
			}).finally(() => setLoading(false));
	}, []);

	useEffect(() => {
		if(!selectedClient) return;

		setLoading(true);
		
		getContractsByClient(selectedClient.id)
			.then(({ data }) => setData(data))
			.finally(() => setLoading(false));

	}, [selectedClient]);

	return (
		<Row gutter={[24, 24]} style={{ marginTop: '2rem', marginLeft: '2rem', marginRight: '2rem' }}>
			<Col span={24}>
				<Title level={2}>Servicios</Title>
				<hr className="hr-title" />
			</Col>
			<Col span={24}>
				<Radio.Group style={{ width: '100%' }}>
					<Row gutter={16} justify="space-between">
						{STATUS_STYLES
							.filter(s => auth.isInRole(s.rol))
							.map(({ rol, ...rest }) => {
								const count = stats[rest.status] || 0;

								return <Col key={rest.status}>
									<StyledRadio {...rest} count={count} disabled={loading} />
								</Col>
							})}
					</Row>
				</Radio.Group>
			</Col>
			<Col span={24}>
				<Row justify="space-between" align="middle">
					<Col>
						<ClientSelect style={{ width: '400px' }} onChange={(c) => setSelectedClient(c)} />
					</Col>
					<Col>
						<Button
							type='primary'
							size='large'
							icon={<FaPlusCircle />}
							onClick={() => navigate('/intelinet/servicios/contrato')}
							disabled={!auth.isInRole("SERVICE_CREATE")}>
							Nuevo
						</Button>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<ServicesTable dataSource={data} loading={loading} />
			</Col>
		</Row>
	);
}
